<template>
  <div class="mainDiv">
    <div style="width: 100%; height: 2px; background: #79bbff; margin-top: -2px"/>
    <div class="leftDiv">
      <el-tree ref="tree" node-key="id" :props="defaultProps" highlight-current :load="loadNode" lazy @node-click="handleNodeClick"></el-tree>
    </div>
    <div class="rightDiv">
      <el-table
        :data="tableData"
        border
        size="mini"
        :header-cell-style="{background:'#F5F7FA',color:'#606266'}"
        style="width: 100%"
        height="98%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="name"
          align="left"
          header-align="center"
          :show-overflow-tooltip='true'
          label="名称">
        </el-table-column>
        <el-table-column
          prop="code"
          label="编码"
          align="left"
          header-align="center"
          width="80"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
          prop="templateType"
          label="模板类型"
          lign="left"
          width="90"
          header-align="center"
          :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            {{ getTemplateTypeName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          prop="attr"
          label="属性"
          lign="left"
          header-align="center"
          :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {getList, listById, listByPath} from "../api/dftdStore";
  import {getCategoryList} from "../api/category";

  export default {
    name: "TemplateConfigurationTool",
    props: {
      parentMsg: Object
    },
    data() {
      return {
        tableData:[],
        templateTypes: [],
        defaultProps: {
          children: 'childrens',
          label: 'displayName',
          isLeaf: 'leaf'
        }
      }
    },
    methods: {
      loadNode(node, resolve) {
        if (node.level=== 0) {
          this.getMainTreeData(resolve)
        } else {
          this.getTreeData(node.data.id, resolve)
        }
      },
      getMainTreeData(resolve) {
        listByPath().then(response => {
          for (var index in response.rows) {
            response.rows[index].leaf = response.rows[index].children == 0
          }
          resolve(response.rows)
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      getTreeData(id, resolve) {
        listById(id, this.$qs.stringify({id:id})).then(response => {
          for (var index in response.rows) {
            response.rows[index].leaf = response.rows[index].children == 0
          }
          resolve(response.rows)
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      handleNodeClick(data) {
        this.getTableData(data.id)
      },
      handleSelectionChange(selection) {
        this.$emit('getSelectTemplate', selection)
      },
      getTableData(category) {
        getList(category).then(response => {
          this.tableData = response.rows
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      getTemplateTypes() {
        getCategoryList('key', 'mblx').then(res => {
          if (res.succeed) {
            this.templateTypes = res.data
            console.log(this.templateTypes)
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      getTemplateTypeName(data) {
        for (var i = 0; i < this.templateTypes.length; i++) {
          if (this.templateTypes[i].code === data.templateType) {
            return this.templateTypes[i].name
          }
        }

        return data.code
      }
    },
    watch: {
      parentMsg() {
        this.$refs.tree.setCurrentKey(null)
        this.tableData = []
      }
    },
    mounted() {
      this.getTemplateTypes()
    }
  }
</script>

<style scoped>
  .mainDiv {
    width: 100%;
    height: 100%;
  }
  .leftDiv {
    width: 25%;
    height: 100%;
    float: left;
    overflow-y: auto;
  }

  .rightDiv {
    width: 74%;
    height: 100%;
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/TemplateConfigurationTool.vue